import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import {
  provideRouterStore,
  FullRouterStateSerializer,
} from '@ngrx/router-store'

export function provideRouterStoreConfig(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideRouterStore({
      serializer: FullRouterStateSerializer,
      stateKey: 'router',
    }),
  ])
}
